export default __webpack_public_path__ + "static/media/card-swipe.f8bbd755.jpg";